<div
  class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-flex tw-items-center tw-justify-center tw-z-[1000] tw-bg-[#00000088]"
  *ngIf="showLoadingOverlay">
  <loading [stroke]="'#fff'"></loading>
</div>

<div class="tw-fixed tw-left-0 tw-right-0 tw-h-1 tw-overflow-hidden tw-z-[100] tw-bg-[#ffffff3f]"
  *ngIf="showLinearLoading">
  <div class="tw-relative tw-w-full tw-h-full
    before:tw-w-content-[''] before:tw-absolute before:tw-h-full before:tw-bg-teal-500 before:tw-animate-line1
    after:tw-w-content-[''] after:tw-absolute after:tw-h-full after::tw-bg-teal-500 after::tw-animate-line1"></div>
</div>

<div class="tw-h-full tw-w-full tw-overflow-hidden"
  [ngClass]='{ "tw-select-text": isInternalUser, "native": isNative }'>
  <div class="tw-overflow-hidden tw-h-full tw-w-full tw-fixed">
    <router-outlet></router-outlet>
  </div>
</div>

<div class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-z-10 tw-bg-[#0000003f] tw-backdrop-blur-sm"
  *ngIf="openShareOptions" (click)="hideMoreOption()"></div>
<div
  class="tw-fixed tw-bottom-0 tw-left-4 tw-right-4 tw-top-auto tw-z-20 tw-py-2 tw-rounded-tr-6 tw-rounded-tl-6 tw-overflow-hidden tw-shadow-z1 tw-bg-white"
  style="transform: translateY(110%);" [ngClass]='{ "tw-animate-slide_in_bottom_forwards": openShareOptions }'
  (click)="stopPropagation($event)">
  <div class="tw-flex tw-items-center tw-px-4 tw-py-3 tw-gap-4" (click)='shareApp("WHATSAPP")'>
    <div class="tw-block tw-bg-social-stripe tw-bg-size-[150px] tw-h-10 tw-w-10 tw-scale-[0.65]"
      style="background-size: 150px; background-position: 677px 151px;"></div>
    <span class="tw-text-300 tw-font-body">WhatsApp</span>
  </div>
  <div class="tw-flex tw-items-center tw-px-4 tw-py-3 tw-gap-4" (click)='shareApp("COPY")'>
    <div class="tw-block tw-bg-social-stripe tw-bg-size-[150px] tw-h-10 tw-w-10 tw-scale-[0.65]"
      style="background-size: 150px; background-position: 752px 151px"></div>
    <span class="tw-font-body tw-text-300">Copy</span>
  </div>
</div>
<textarea id="clipboard" class="tw-appearance-none tw-h-0 tw-w-0 tw-border-0 tw-p-0 tw-min-h-0 tw-relative tw-z-[-1]"></textarea>

<div
  class="tw-fixed tw-top-0 tw-left-0 tw-right-0 tw-bottom-0 tw-flex tw-items-center tw-justify-center tw-z-[1000] tw-bg-[#0000003f] tw-backdrop-blur-sm"
  *ngIf="uploadingProgressBar.show">
  <div class="uploading-progress tw-py-8 tw-px-7 tw-rounded-3 tw-w-4/5">
    <div class="tw-text-center tw-text-300 tw-font-body tw-mb-3" i18n="@@uploadInProgress">
      Upload in progress
    </div>
    <div class="tw-text-400 tw-text-center tw-mb-4 tw-font-body">{{uploadingProgressBar.percentageLoaded}}%</div>
    <div class="tw-w-full tw-h-1.5 tw-rounded-full tw-overflow-hidden tw-bg-gray-100 tw-mb-5">
      <div class="tw-h-full tw-transition-all tw-bg-blue-400" #progressBar=""
        [style.width]='uploadingProgressBar.percentageLoaded+"%"'></div>
    </div>
    <div class="tw-text-right tw-text-gray-400 tw-text-200 tw-tracking-wide tw-font-body tw-uppercase" i18n="@@cancel"
      (click)="cancelUploadingFile()">Cancel</div>
  </div>
</div>

<app-notification [(message)]="notifyMessage" [variant]="notifyVariant"></app-notification>

<pop-up-modal *ngIf="popUpModal && popUpModal.open" [config]="popUpModal" (close)="popUpClosed($event)"></pop-up-modal>

<pop-up *ngIf="popUp?.open && cashValue !== 0" class="tw-p-4 tw-rounded-3 tw-overflow-hidden" [show]="popUp?.open"
  [triggerDismiss]="true" (close)="closePopup()">
  <div class="tw-bg-white tw-bg-gradient-teal-top -tw-m-4 tw-px-10 tw-pb-10 tw-pt-12">
    <div class="tw-text-500 tw-font-body tw-font-bold tw-text-black tw-mb-8" i18n="@@congratulations">Congratulations!</div>
    <div class="tw-text-300 tw-font-body tw-mb-18">
      <div class="tw-mb-1" i18n="@@gotFreeCash">
        You just won ₹{{cashValue}} CureSkin Cash as a surprise gift for
        visiting this page.
      </div>
      <div class="tw-underline" (click)="goToWallet()" i18n="@@goToWallet">
        Click here to see the wallet.
      </div>
    </div>
    <ng-lottie *ngIf="showConfettiAnimation" width="100%" [styles]="styles" [options]="options"></ng-lottie>
    <div id="payButton"
         class="tw-bg-teal-600 tw-w-full tw-text-white tw-rounded-full tw-h-12 tw-flex tw-justify-center tw-items-center tw-text-500 tw-font-semibold"
         (click)="closePopup()"><span
      i18n="@@ok">Ok</span></div>
  </div>
</pop-up>

<!-- Global discontinued/restricted popup host (with alternate) -->
<pop-up *ngIf="discontinuedPopup?.open" class="tw-p-4 tw-rounded-3 tw-overflow-hidden" [show]="discontinuedPopup?.open"
  [triggerDismiss]="true" (close)="closeDiscontinuedPopup(false)">
  <discontinued-popup
    [oldProductData]="discontinuedPopup?.oldProduct"
    [newProductData]="discontinuedPopup?.newProduct"
    (changeProduct)="closeDiscontinuedPopup(true)"
    (articleOpen)="handleDiscontinuedReadMore()">
  </discontinued-popup>
</pop-up>

<!-- Global info popup when no alternate exists -->
<pop-up *ngIf="discontinuedInfoPopup?.open" class="tw-p-4 tw-rounded-3 tw-overflow-hidden" [show]="discontinuedInfoPopup?.open"
  [triggerDismiss]="true" (close)="closeDiscontinuedInfo()">
  <discontinued-info-popup (close)="closeDiscontinuedInfo()">
  </discontinued-info-popup>
</pop-up>

<!-- Named outlet for reminder page -->
<router-outlet name="reminder"></router-outlet>
